var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3214 5.01163H7.70539C6.02073 5.01163 5.0908 6.96699 6.15397 8.2738L12.0714 15.5473M12.0714 15.5473L18.3446 8.14495C19.3925 6.90843 18.5137 5.01163 16.8929 5.01163V5.01163M12.0714 15.5473V21.9759M18.5 2.51163C17.5476 2.39258 15.3571 3.11877 14.2143 6.97591M12.0714 21.9759H6.17857M12.0714 21.9759H17.9643",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.8572,
    cy: 8.21401,
    r: 1.07143,
    fill: "#BF9A6D",
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.d0a720e2593b3c1227f722c308220055.svg";
export { ForwardRef as ReactComponent };